export const PaginationMixin = {  
  data: function () {     
    return { 
               
    }
  },
  methods: {
      getPaginationLinks: function(callUrl, countUrl, itemsPerPage) {     
                                
        this.$http.get(countUrl).then(response => {               
            var numOfPages = response.body.map(obj => {                                                                                                                                                                                         
                return Math.ceil(obj.count / itemsPerPage);
            });                     

            this.pagesInfo = [];
            for(var i = 0; i < numOfPages; i++)
              this.pagesInfo.push(callUrl + (i*itemsPerPage));    
                                                                
        }, response => {            
            //eventBus.$emit('errorMsg',response);
        });

    },        
  }
};


// WEBPACK FOOTER //
// ./src/components/mixin/PaginationMixin.js